import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
// import HelmetHead from '../utils/HelmetHead'
import CreateForm from './create/CreateForm'

// State
import { setpageTitle } from '../../store/actions/siteInfo'

class CustomerAccountInfo extends Component {
    constructor(props){
        super(props)
        this.props.setpageTitle('Account Info')
    }

    render() {
        return (
            <div>
                {/* <HelmetHead title="Account Info" /> */}

                <h1>Customer Account - Information</h1>
				
                <div className="padded_bottom">
                    You can update your account information here.<br />
                    This info will be used as the default billing address for your account.
                </div>

                <CreateForm customer={this.props.customer} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        customer: state.user.customer.user
    }
}

export default connect(mapStateToProps, { setpageTitle })(CustomerAccountInfo)



// WEBPACK FOOTER //
// ./src/components/customer/CustomerAccountInfo.js